import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, BookOpen } from "lucide-react";

// Renders WEB passage text for a reference.
export const EsvPassage = ({ reference, dark = false }) => {
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    if (!reference) return;
    let active = true;
    setState({ loading: true, data: null, error: null });
    api
      .get("/bible/passage", { params: { q: reference } })
      .then(({ data }) => active && setState({ loading: false, data, error: null }))
      .catch((e) =>
        active &&
        setState({
          loading: false,
          data: null,
          error: e?.response?.data?.detail || "Could not load the passage.",
        })
      );
    return () => { active = false; };
  }, [reference]);

  const base = dark ? "text-parchment/85" : "text-ink/80";

  if (state.loading) {
    return (
      <div className={`flex items-center gap-2 text-sm ${dark ? "text-parchment/60" : "text-ink/50"}`}>
        <Loader2 className="w-4 h-4 animate-spin" /> Loading ESV text…
      </div>
    );
  }
  if (state.error) {
    return <p className={`text-sm ${dark ? "text-parchment/60" : "text-ink/50"}`}>{state.error}</p>;
  }
  if (!state.data) return null;

  return (
    <div data-testid="esv-passage">
      <div className={`flex items-center gap-2 mb-3 font-mono text-[11px] uppercase tracking-widest ${dark ? "text-gold" : "text-olive"}`}>
        <BookOpen className="w-4 h-4" /> {state.data.canonical} · {state.data.translation || "WEB"}
      </div>
      <div className={`font-serif text-lg sm:text-xl leading-relaxed whitespace-pre-line ${base}`}>
        {state.data.passage}
      </div>
      <p className={`text-[11px] mt-4 ${dark ? "text-parchment/40" : "text-ink/40"}`}>
        Scripture taken from the World English Bible (public domain).
      </p>
    </div>
  );
};
